import './search.less';
import './search-autocomplete/search-autocomplete';
import { eventsSender } from 'globalState/global-state.js';

$(function () {
    $('.search .tabs li').on('click', function () {
        var id = $(this).index() + 1;

        /** @doc Последняя вкладка отрабатывает как ссылка */
        if (id === $('.search .tabs li').length) return;

        $('.search .tabs li').removeClass('active');
        $(this).addClass('active');

        $('.search-form-container b').removeClass('active');
        $('.search-form-container b').eq(id).addClass('active');
    });

    $('.search li[data-code="mark"]').click(function () {
        var conainer = $('.search div.search-form-container').find(
            '#tab_' + $(this).attr('data-code')
        );
        var sconainer = $('<div></div>').attr('class', 'sub');
        var topUl = $('<ul></ul>').attr('class', 'top');

        if (!conainer.attr('loaded')) {
            $.ajax({
                url: $(this).attr('data-url'),
                success: function (data) {
                    var i = 1;
                    $.each(data, function (index, item) {
                        topUl.append(
                            $('<li>' + item.name + '</li>').attr(
                                'data-child',
                                i
                            )
                        );
                        var ul = $('<ul></ul>').attr('data-parent', i);
                        let i1 = 0; // eslint-disable-line

                        $.each(item.childs, function (sindex, sitem) {
                            ul.append(
                                $(
                                    '<li><a href="' +
                                        sitem.url +
                                        '">' +
                                        sitem.name +
                                        '</a></li>'
                                )
                            );
                            i1++;
                        });

                        sconainer.append(ul);
                        i++;
                    });

                    conainer.append(topUl);
                    conainer.append(sconainer);
                    conainer.attr('loaded', 1);

                    $(
                        '.search div.search-form-container .search-marks ul.top li:first-child'
                    ).addClass('active');
                    $(
                        '.search div.search-form-container .search-marks div.sub ul[data-parent=1]'
                    ).addClass('active');
                },
                complete: function () {
                    $('#tab_mark .top li').on('click', function () {
                        var id = $(this).index();

                        $('#tab_mark .top li').removeClass('active');
                        $(this).addClass('active');

                        $('#tab_mark .sub ul').removeClass('active');
                        $('#tab_mark .sub ul').eq(id).addClass('active');
                    });
                },
                dataType: 'json',
            });
        }
    });

    $('.search li[data-code="selection"]').click(function () {
        var conainer = $('.search div.search-form-container').find(
            '#tab_' + $(this).attr('data-code')
        );
        var sconainer = $('<div></div>').attr('class', 'sub');

        var topUl = $('<ul></ul>').attr('class', 'top');

        if (!conainer.attr('loaded')) {
            $.ajax({
                url: $(this).attr('data-url'),
                success: function (data) {
                    var i = 1;
                    $.each(data, function (index, item) {
                        topUl.append(
                            $('<li>' + item.name + '</li>').attr(
                                'data-child',
                                i
                            )
                        );
                        var ul = $('<ul></ul>').attr('data-parent', i);
                        var i1 = 0; // eslint-disable-line

                        $.each(item.childs, function (sindex, sitem) {
                            ul.append(
                                $(
                                    '<li><a href="' +
                                        sitem.url +
                                        '">' +
                                        sitem.name +
                                        '</a></li>'
                                )
                            );
                            i1++;
                        });

                        sconainer.append(ul);
                        i++;
                    });

                    conainer.append(topUl);
                    conainer.append(sconainer);
                    conainer.attr('loaded', 1);

                    $(
                        '.search div.search-form-container .search-marks ul.top li:first-child'
                    ).addClass('active');
                    $(
                        '.search div.search-form-container .search-marks div.sub ul[data-parent=1]'
                    ).addClass('active');
                },
                complete: function () {
                    $('#tab_selection .top li').on('click', function () {
                        var id = $(this).index();

                        $('#tab_selection .top li').removeClass('active');
                        $(this).addClass('active');

                        $('#tab_selection .sub ul').removeClass('active');
                        $('#tab_selection .sub ul').eq(id).addClass('active');
                    });
                },
                dataType: 'json',
            });
        }
    });

    $(document).mouseup(function (e) {
        var container = $('#tab_mark');
        if (
            container.hasClass('active') &&
            !container.is(e.target) &&
            container.has(e.target).length === 0
        ) {
            $('.search li[data-code="main"]').click();
        }

        container = $('#tab_selection');
        if (
            container.hasClass('active') &&
            !container.is(e.target) &&
            container.has(e.target).length === 0
        ) {
            $('.search li[data-code="main"]').click();
        }
    });

    $('.global-search-form').on('submit', function (event) {
        if (!$(this).find('.text').val()) {
            event.preventDefault();
        }
    });

    $(document).on('click', '#tab_selection .sub a', function () {
        eventsSender('tecdoc', 'searchMarkSelect', {
            mark: $(this).text(),
        });
    });
});
